import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoucherTemplateComponent } from '@core/components/voucher-template/components/voucher-template.component';
import type { VoucherTemplateInput } from '@core/components/voucher-template/components/voucher-template.interface';
import type { GetPaymentResponseRequest } from '@core/services/cash-processor.interface';
import type { InstructionStepper } from '@core/components/instruction-stepper/instruction-stepper.interfaces';
import type { LinearStepInfo } from '@core/components/linear-step-info/linear-step-info.interfaces';

@Component({
  selector: 'dcv-voucher-pdf-container',
  standalone: true,
  imports: [CommonModule, VoucherTemplateComponent],
  templateUrl: './voucher-pdf-container.component.html',
  styleUrl: './voucher-pdf-container.component.scss',
})
export class VoucherPdfContainerComponent {
  @Input({ required: true }) linearStep: LinearStepInfo[] = []
  @Input() color!: string;
  @Input() paymentMethod = 'Cash';
  @Input() selectedBankCode = '';
  @Input() voucherData: GetPaymentResponseRequest | null = null;

  get pdfVoucher(): VoucherTemplateInput | null {
    return this.buildPdfVoucher();
  }

  private mapInstructions(
    bank: NonNullable<GetPaymentResponseRequest['voucherConfig']>['bankList'][number],
  ): InstructionStepper[] {
    const method = bank?.paymentMethodInstructions?.find((i) => i.method === this.paymentMethod);
    return method?.instructions?.map((instruction) => ({
      step: instruction?.order,
      description: instruction?.value,
    } as InstructionStepper)) ?? [];
  }

  private buildPdfVoucher(): VoucherTemplateInput | null {
    if (!this.voucherData?.voucherConfig) {
      return null;
    }

    const bankList = this.voucherData.voucherConfig.bankList ?? [];
    const banks = this.selectedBankCode
      ? bankList.filter((bank) => bank.bankCode === this.selectedBankCode)
      : bankList;

    const paymentInstructions = banks.map((bank) => ({
      bank: bank?.bankCode,
      hexColor: bank?.hexColor,
      instruction: this.mapInstructions(bank),
    }));

    return {
      LinearStepInfo: this.linearStep,
      paymentInstructions,
      generalInstructions: paymentInstructions[0]?.instruction ?? [],
    };
  }
}
